import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sex-registry',
  templateUrl: './sex-registry.component.html',
  styleUrls: ['./sex-registry.component.sass']
})
export class SexRegistryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
